import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = {
  // Services
  getServices: () => axios.get(`${API}/services`),
  getService: (slug) => axios.get(`${API}/services/${slug}`),
  
  // Locations
  getLocations: () => axios.get(`${API}/locations`),
  getLocation: (id) => axios.get(`${API}/locations/${id}`),
  
  // Blog
  getBlogPosts: (category = null, limit = 20) => {
    let url = `${API}/blog?limit=${limit}`;
    if (category) url += `&category=${category}`;
    return axios.get(url);
  },
  getBlogPost: (slug) => axios.get(`${API}/blog/${slug}`),
  
  // Team
  getTeamMembers: () => axios.get(`${API}/team`),
  
  // Consultations
  createConsultation: (data) => axios.post(`${API}/consultations`, data),
  getConsultations: (status = null) => {
    let url = `${API}/consultations`;
    if (status) url += `?status=${status}`;
    return axios.get(url);
  },
  updateConsultation: (id, data) => axios.patch(`${API}/consultations/${id}`, data),
  deleteConsultation: (id) => axios.delete(`${API}/consultations/${id}`),
  
  // Appointments
  createAppointment: (data) => axios.post(`${API}/appointments`, data),
  getAppointments: (params = {}) => axios.get(`${API}/appointments`, { params }),
  getAvailableSlots: (locationId, date, serviceId) => 
    axios.get(`${API}/appointments/available-slots?location_id=${locationId}&date=${date}&service_id=${serviceId}`),
  updateAppointment: (id, data) => axios.patch(`${API}/appointments/${id}`, data),
  deleteAppointment: (id) => axios.delete(`${API}/appointments/${id}`),
  
  // Admin
  getAdminStats: () => axios.get(`${API}/admin/stats`),
  
  // Blog Admin
  createBlogPost: (data) => axios.post(`${API}/blog`, data),
  updateBlogPost: (id, data) => axios.patch(`${API}/blog/${id}`, data),
  deleteBlogPost: (id) => axios.delete(`${API}/blog/${id}`),
  
  // Location Admin
  createLocation: (data) => axios.post(`${API}/locations`, data),
  updateLocation: (id, data) => axios.patch(`${API}/locations/${id}`, data),
  deleteLocation: (id) => axios.delete(`${API}/locations/${id}`),
};

export default api;
